import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

export enum AmaronServiceCategoryEnum {
    BOOKED = "a1190580-1796-4d7e-9891-ae7f1bfadacf",
    CANCELLED = "4e4806be-9e22-49a4-9b3a-db35761bfea2",
    DELIVERED = "f91f9d29-d707-4df8-814d-99ecc05d5124",
    RE_SCHEDULED = "2080310f-1888-4f33-a0a4-9edd2da4acc0",
    ARCHIVE = "1f71d938-5adb-49c7-8a2f-c74e0ed4c32f",
}

export enum AmaronServiceBookingStatusEnum {
    ADVISOR_ASSIGNED = "a3b4c5d6-e7f8-4901-a234-567890abcdef",
    CONFIRMED = "b4c5d6e7-f8a9-4012-b345-678901bcdef0",
    MARSHAL_ASSIGNED = "c5d6e7f8-a9b0-4123-8456-789012cdef01",
    CANCELLED = "d6e7f8a9-b0c1-4234-8567-890123def012",
    COMPLETED = "e7f8a9b0-c1d2-4345-8678-901234ef0123",
    IN_PROGRESS = "f8a9b0c1-d2e3-4456-8789-012345f01234",
}

export const amaronServiceBookingStatuses: Record<AmaronServiceBookingStatusEnum, {id: Uuid; displayName: string}> = {
    [AmaronServiceBookingStatusEnum.ADVISOR_ASSIGNED]: {
        id: AmaronServiceBookingStatusEnum.ADVISOR_ASSIGNED as Uuid,
        displayName: "Advisor_assigned",
    },
    [AmaronServiceBookingStatusEnum.CONFIRMED]: {
        id: AmaronServiceBookingStatusEnum.CONFIRMED as Uuid,
        displayName: "Confirmed",
    },
    [AmaronServiceBookingStatusEnum.MARSHAL_ASSIGNED]: {
        id: AmaronServiceBookingStatusEnum.MARSHAL_ASSIGNED as Uuid,
        displayName: "Marshal_assigned",
    },
    [AmaronServiceBookingStatusEnum.CANCELLED]: {
        id: AmaronServiceBookingStatusEnum.CANCELLED as Uuid,
        displayName: "Cancelled",
    },
    [AmaronServiceBookingStatusEnum.COMPLETED]: {
        id: AmaronServiceBookingStatusEnum.COMPLETED as Uuid,
        displayName: "Completed",
    },
    [AmaronServiceBookingStatusEnum.IN_PROGRESS]: {
        id: AmaronServiceBookingStatusEnum.IN_PROGRESS as Uuid,
        displayName: "In_progress",
    },
};

export function getAmaronServiceBookingStatusSelectOptions(): Array<{id: Uuid; displayName: string}> {
    return Object.values(amaronServiceBookingStatuses).map((status) => ({
        id: status.id,
        displayName: status.displayName,
    }));
}

export enum AmaronEventTypes {
    "Enquiry" = "7f2a8f19-bfae-404e-9dd9-d6944f63756d",
    "Calls" = "817dc5c0-de7a-4269-ac41-9151936e6d9c",
    "Service" = "b18132dd-c2ec-47bf-9629-f85977c550a1",
}

// Stable migration IDs for direct tooling/debugging. Runtime code resolves these columns from template configuration.
export const AMARON__EVENT__CALLS__DISPOSITION__COLUMN_ID = "6fbd2c38-bd2f-4f45-9bb7-1c45d19652fa" as Uuid;

export const AMARON__EVENT__ENQUIRY__DISPOSITION__COLUMN_ID = "226cbc38-577e-46ab-a545-8d9cef58f30d" as Uuid;

export const AMARON__EVENT__SERVICE__DISPOSITION__COLUMN_ID = "82ee5826-a846-414e-aee9-79beab6f3f0c" as Uuid;

export const AMARON__EVENT__CALLS__L1_DISPOSITION__COLUMN_ID = "78dbe749-2491-42eb-a299-45205e6fbee7" as Uuid;

export const AMARON__EVENT__CALLS__L2_DISPOSITION__COLUMN_ID = "96388074-c451-4972-8d7a-0f1b31fb42ee" as Uuid;

export const AMARON__EVENT__CALLS__L3_DISPOSITION__COLUMN_ID = "669070bc-c4a2-49ef-a262-34cdee3045d4" as Uuid;

export const AMARON__EVENT__CALLS__L4_DISPOSITION__COLUMN_ID = "00dcdb67-900a-493b-8aeb-6e52c1043f69" as Uuid;

export const AMARON__EVENT__ENQUIRY__CUSTOMER_NAME__COLUMN_ID = "59cea62b-b5db-44ac-9462-eecd763b309d" as Uuid;

export const AMARON__EVENT__ENQUIRY__CONTACT_NUMBER__COLUMN_ID = "9dfa36cd-e593-4bab-939d-89bb4395e244" as Uuid;

export const AMARON__EVENT__ENQUIRY__ENQUIRY_STATUS__COLUMN_ID = "09b4da90-1883-403b-83ea-b32223313123" as Uuid;

export const AMARON__EVENT__ENQUIRY__CUSTOMER_HOUSE_NO__COLUMN_ID = "6bd30a0d-dc06-42e0-bc30-b8cbade972cb" as Uuid;

export const AMARON__EVENT__ENQUIRY__CUSTOMER_STATE__COLUMN_ID = "9c815634-551b-46ec-aeb3-fb6527ce3d62" as Uuid;

export const AMARON__EVENT__ENQUIRY__CUSTOMER_CITY__COLUMN_ID = "958270ea-639f-4505-9401-1755a2c292cd" as Uuid;

export const AMARON__EVENT__ENQUIRY__FUEL_TYPE__COLUMN_ID = "8ed336cc-ecf5-47d9-bd15-ae87656d2420" as Uuid;

export const AMARON__EVENT__ENQUIRY__AD_NAME__COLUMN_ID = "c5bd4fce-f3ad-4af1-ace8-7eb5ae8b611e" as Uuid;

export const AMARON__EVENT__ENQUIRY__AD_SET_NAME__COLUMN_ID = "dc6e0953-a8ec-43d7-90a0-d0e1f4dbe698" as Uuid;

export const AMARON__EVENT__ENQUIRY__UTM_PLATFORM__COLUMN_ID = "7d67e636-6bd8-4d14-87b6-66b1b8a138f9" as Uuid;

export const AMARON__EVENT__ENQUIRY__UTM_SOURCE__COLUMN_ID = "caab2af2-ce5c-419b-84ce-ec86b541a0c1" as Uuid;

export const AMARON__EVENT__ENQUIRY__UTM_MEDIUM__COLUMN_ID = "b53957b1-3709-40b6-9b5e-34741d6128d3" as Uuid;

export const AMARON__EVENT__ENQUIRY__UTM_CAMPAIGN__COLUMN_ID = "4d7ee0e5-3605-4c8d-bc8a-741b54947a2a" as Uuid;

export const AMARON__EVENT__ENQUIRY__UTM_TERM__COLUMN_ID = "53449fb9-6c92-4bdb-8175-d69f5cbc3660" as Uuid;

export const AMARON__EVENT__ENQUIRY__UTM_CONTENT__COLUMN_ID = "413eae69-94c8-4ff3-a262-52afd8f8220b" as Uuid;

export const AMARON__EVENT__ENQUIRY__GAD_SOURCE__COLUMN_ID = "fa5e9cc2-e1bf-410b-a569-d2de6fe95c45" as Uuid;

export const AMARON__EVENT__ENQUIRY__GAD_CAMPAIGN_ID__COLUMN_ID = "9ca71cd9-c1e1-42d5-8a2d-a30af76395a3" as Uuid;

export const AMARON__EVENT__ENQUIRY__GBRAID__COLUMN_ID = "195526b9-22b4-4adf-b6fc-e75a9f3a95ca" as Uuid;

export const AMARON__EVENT__ENQUIRY__GCLID__COLUMN_ID = "a6de60cf-fbf9-429a-b477-922055490903" as Uuid;

export const AMARON__EVENT__ENQUIRY__FAD_SOURCE__COLUMN_ID = "d94b24b8-ecf1-4704-bbdb-f3688dae8f3d" as Uuid;

export const AMARON__EVENT__ENQUIRY__FAD_CAMPAIGN_ID__COLUMN_ID = "f4b9f251-4ab7-4c2c-9ecb-07bf1ab520ba" as Uuid;

export const AMARON__EVENT__ENQUIRY__FBRAID__COLUMN_ID = "e1b9c6db-44a5-48a8-a83c-7c48d0f3ac04" as Uuid;

export const AMARON__EVENT__ENQUIRY__FBCLID__COLUMN_ID = "929dac26-b293-45af-8d90-65c774856d4b" as Uuid;

export const AMARON__EVENT__ENQUIRY__CUSTOMER_VOC__COLUMN_ID = "2317d592-fd95-4a18-b4aa-e7c5221f0cb9" as Uuid;

export const AMARON__EVENT__ENQUIRY__SERVICE_REQUESTED__COLUMN_ID = "7f340e29-795f-42ba-bf61-9fc1f8ce9af5" as Uuid;

export const AMARON__EVENT__ENQUIRY__CAR_MAKE__COLUMN_ID = "7bad43eb-44c3-4cee-b18b-f6160610ae94" as Uuid;

export const AMARON__EVENT__ENQUIRY__CAR_MODEL__COLUMN_ID = "a10067c3-bcc5-45fa-bcbc-02f22c0a236c" as Uuid;

export const AMARON__EVENT__ENQUIRY__SMARTPING_CAMPAIGN__COLUMN_ID = "8a1865dc-0334-4c7c-b375-1a7e5b46d7cc" as Uuid;

export const AMARON__EVENT__CALLS__CALL_STATUS__COLUMN_ID = "06f7bc9d-6f3b-418f-bf58-4f85a59e7537" as Uuid;

export const AMARON__EVENT__CALLS__LAST_DISPOSITION__COLUMN_ID = "7d176d03-8aba-456f-a448-2931c49f9e98" as Uuid;

export const AMARON__EVENT__CALLS__REMARKS__COLUMN_ID = "503e38d1-05cb-4080-8c6c-1d7e3f5981a1" as Uuid;

export const AMARON__EVENT__CALLS__LAST_CALL_DATE__COLUMN_ID = "fc5960d2-761c-470e-8712-260fbcad0a87" as Uuid;

export const AMARON__EVENT__CALLS__SCHEDULED_BY__COLUMN_ID = "99a17c4e-18bd-4db7-92d9-97d431a22fae" as Uuid;

export const AMARON__EVENT__CALLS__SCHEDULED_ON__COLUMN_ID = "f766f9aa-ea7f-4204-9219-4008668bebe8" as Uuid;

export const AMARON__EVENT__CALLS__LOGGED_BY__COLUMN_ID = "dc2073ed-6d3a-4a0e-b68f-79b357a4e23d" as Uuid;

export const AMARON__EVENT__CALLS__LOGGED_ON__COLUMN_ID = "e94d06f1-3c0a-48be-a66b-eb46449a1219" as Uuid;

export const AMARON__EVENT__CALLS__CANCELLED_BY__COLUMN_ID = "5f7bc7b4-1475-4387-a547-e0e06cff7f02" as Uuid;

export const AMARON__EVENT__CALLS__CANCELLED_ON__COLUMN_ID = "80fb8802-a50f-47f6-85ac-7bf80e510a49" as Uuid;

export const AMARON__EVENT__CALLS__CANCELLATION_REASON__COLUMN_ID = "ddc00cef-b4b5-4bfd-97aa-adb752bad1df" as Uuid;

export const AMARON__EVENT__CALLS__CREATED_BY_ROLE__COLUMN_ID = "e6102607-f0f3-49c6-856f-e252ddbb1abc" as Uuid;

export const AMARON__EVENT__CALLS__SCHEDULE_DATE__COLUMN_ID = "02fb1390-f6ee-42ef-8195-92fa70ebbc59" as Uuid;

export const AMARON__EVENT__CALLS__CUSTOMER_NAME__COLUMN_ID = "a4ce01b0-4b49-4bee-98cb-9aa368ae973c" as Uuid;

export const AMARON__EVENT__CALLS__CONTACT_NUMBER__COLUMN_ID = "c345d0f5-44c0-4bba-ab1d-ca0876ed865d" as Uuid;

export const AMARON__EVENT__CALLS__CALL_COUNT__COLUMN_ID = "af6904dd-44b4-4d59-a2ac-e8adf8aad28d" as Uuid;

export const AMARON__EVENT__CALLS__CUSTOMER_STATE__COLUMN_ID = "7fc59046-8c2b-40a3-bc8e-b2d1f4b9c154" as Uuid;

export const AMARON__EVENT__CALLS__CUSTOMER_CITY__COLUMN_ID = "07c83bad-213f-47fb-b626-e04836a0ce83" as Uuid;

export const AMARON__EVENT__CALLS__ACTION_PLATFORM__COLUMN_ID = "15bb0723-bcb9-4d54-b6bd-5f5c25b313a1" as Uuid;

export const AMARON__EVENT__CALLS__UTM_PLATFORM__COLUMN_ID = "fdd19202-62ae-4890-9c31-2e0c22d26582" as Uuid;

export const AMARON__EVENT__CALLS__UTM_SOURCE__COLUMN_ID = "012be90f-6a1e-4e62-89b8-8866f6c070c0" as Uuid;

export const AMARON__EVENT__CALLS__UTM_MEDIUM__COLUMN_ID = "a5726752-09f9-4d1d-9514-5c0c4e620f08" as Uuid;

export const AMARON__EVENT__CALLS__UTM_CAMPAIGN__COLUMN_ID = "19a24e67-9bb4-43e6-a255-c89caac186f6" as Uuid;

export const AMARON__EVENT__CALLS__UTM_TERM__COLUMN_ID = "be575834-185c-40e7-a16d-9ea92e6a625a" as Uuid;

export const AMARON__EVENT__CALLS__UTM_CONTENT__COLUMN_ID = "d12c4f7b-c822-43ff-963c-f5418755a1b5" as Uuid;

export const AMARON__EVENT__CALLS__GAD_SOURCE__COLUMN_ID = "34d37564-1a4b-41d3-8f7b-52c1e4dda331" as Uuid;

export const AMARON__EVENT__CALLS__GAD_CAMPAIGN_ID__COLUMN_ID = "3ece3c10-8102-473d-ba3b-cf86d6937637" as Uuid;

export const AMARON__EVENT__CALLS__GBRAID__COLUMN_ID = "29df3fbd-5d96-4ecd-a274-2b7eaaa0b127" as Uuid;

export const AMARON__EVENT__CALLS__GCLID__COLUMN_ID = "d4cdad19-d582-4e20-a84e-1f4c309e23a6" as Uuid;

export const AMARON__EVENT__CALLS__FAD_SOURCE__COLUMN_ID = "afece2c7-5826-49fa-932d-16687410eedc" as Uuid;

export const AMARON__EVENT__CALLS__FAD_CAMPAIGN_ID__COLUMN_ID = "ed55086a-1809-4cff-9264-4e7478957f42" as Uuid;

export const AMARON__EVENT__CALLS__FBRAID__COLUMN_ID = "9bad933c-242d-43f7-8884-a6b2556183be" as Uuid;

export const AMARON__EVENT__CALLS__FBCLID__COLUMN_ID = "887135d9-5356-4efe-b08f-418117d03779" as Uuid;

export const AMARON__EVENT__SERVICE__CUSTOMER_NAME__COLUMN_ID = "f670328d-b78a-4236-8405-405d91fc8286" as Uuid;

export const AMARON__EVENT__SERVICE__CONTACT_NUMBER__COLUMN_ID = "7443494d-c182-42bb-b80d-63220c081780" as Uuid;

export const AMARON__EVENT__SERVICE__SMARTPING_CAMPAIGN__COLUMN_ID = "e8e56d9b-1d9a-47d0-ba8d-ef2050e2a306" as Uuid;

export const AMARON__EVENT__SERVICE__BOOKING_STATUS__COLUMN_ID = "31d320a7-bf0e-47e8-969d-6d40303626d3" as Uuid;

export const AMARON__EVENT__SERVICE__CATEGORY__COLUMN_ID = "feed8a0a-abc6-4e92-a10b-8f56ca1f4647" as Uuid;

export const AMARON__EVENT__SERVICE__ORDER_ID__COLUMN_ID = "60350cf9-7c60-4598-a6ca-1c64d02baf57" as Uuid;

export const AMARON__EVENT__SERVICE__PARENT_ORDER_ID__COLUMN_ID = "a0b653d5-8ab5-4e18-8236-7a50f8943dcd" as Uuid;

export const AMARON__EVENT__SERVICE__ASSIGNED_MARSHAL__COLUMN_ID = "ccd57c14-f91b-479f-9016-ce9472f26edb" as Uuid;

export const AMARON__EVENT__SERVICE__MAKE_NAME__COLUMN_ID = "bce35b72-66e6-4ad3-a628-bd3fb9fcac5d" as Uuid;

export const AMARON__EVENT__SERVICE__MODEL_NAME__COLUMN_ID = "4253ab3f-4008-42a0-970f-224ade0a7b24" as Uuid;

export const AMARON__EVENT__SERVICE__FUEL_TYPE__COLUMN_ID = "c9c97c43-7cc1-4196-a172-180aa69f3c90" as Uuid;

export const AMARON__EVENT__SERVICE__SERVICE_REQUESTED__COLUMN_ID = "46b5cb9f-1bb8-4db7-8e27-a7311bd87237" as Uuid;

export const AMARON__EVENT__SERVICE__PACKAGES__COLUMN_ID = "c21c7222-f436-4ddf-b5e8-4013b00211a3" as Uuid;

export const AMARON__EVENT__SERVICE__SUBTOTAL__COLUMN_ID = "4ab0d5db-d8ef-42e7-b37f-1bacdde0e03c" as Uuid;

export const AMARON__EVENT__SERVICE__DISCOUNT_AMOUNT__COLUMN_ID = "d60e7975-15a2-4995-9af4-8e4c037160bd" as Uuid;

export const AMARON__EVENT__SERVICE__TAX_AMOUNT__COLUMN_ID = "93eb0514-e2fb-4e43-890d-24b6f07dbb0f" as Uuid;

export const AMARON__EVENT__SERVICE__SERVICE_CHARGE_AMOUNT__COLUMN_ID = "8b789528-053d-48a1-9438-66fbfdadf068" as Uuid;

export const AMARON__EVENT__SERVICE__TOTAL_AMOUNT__COLUMN_ID = "0f650343-cbe8-4091-af58-6a61fd25acc9" as Uuid;

export const AMARON__EVENT__SERVICE__COUPON_CODE__COLUMN_ID = "cb1a24cc-9bf6-4b6b-bf70-79b373fc3d84" as Uuid;

export const AMARON__EVENT__SERVICE__PAYMENT_LINK_URL__COLUMN_ID = "0c8addd1-3a80-4f20-a9b6-89b28e9c6619" as Uuid;

export const AMARON__EVENT__SERVICE__PAYMENT_LINK_STATUS__COLUMN_ID = "7dbdb307-5979-45be-9982-537d469ee883" as Uuid;

export const AMARON__EVENT__SERVICE__TIME_SLOT__COLUMN_ID = "ebc613f9-e484-4983-83b3-608f5d9cf4b7" as Uuid;

export const AMARON__EVENT__SERVICE__SERVICE_ADVISOR__COLUMN_ID = "a58a0f57-c585-405b-95b8-bd5d5b93b599" as Uuid;

export const AMARON__EVENT__SERVICE__FRANCHISE__COLUMN_ID = "c7eda829-8360-4a56-b178-a6ed6dfed0c3" as Uuid;

export const AMARON__EVENT__SERVICE__NOTES__COLUMN_ID = "a73dbfd7-2bbd-4f31-bef2-69e2eb3dfd38" as Uuid;

export const AMARON__EVENT__SERVICE__SERVICE_STARTED_AT__COLUMN_ID = "51f0341a-24e1-4129-b757-bc2559523794" as Uuid;

export const AMARON__EVENT__SERVICE__SERVICE_COMPLETED_AT__COLUMN_ID = "5a06b922-38aa-42a8-9617-39c0495a24f7" as Uuid;

export const AMARON__EVENT__SERVICE__MECHANIC_ARRIVAL_TIME__COLUMN_ID = "cd541360-d8b6-4451-a5d3-14ec94e96b05" as Uuid;

export const AMARON__EVENT__SERVICE__MECHANIC_DISPATCH_TIME__COLUMN_ID = "cda565af-0434-49d4-9172-8cb380f0c275" as Uuid;

export const AMARON__EVENT__SERVICE__ORDER_STAR_FEEDBACK__COLUMN_ID = "f9b0c1d2-e3f4-4456-a789-012bcdef1234" as Uuid;

export const AMARON__EVENT__SERVICE__ORDER_FEEDBACK_DETAILS__COLUMN_ID = "a0c1d2e3-f4a5-4567-b890-123cdef23456" as Uuid;

export const AMARON__EVENT__SERVICE__BOOKED_BY__COLUMN_ID = "718f19d0-e87b-495c-a7ea-c0c98920fdd6" as Uuid;

export const AMARON__EVENT__SERVICE__BOOKED_ON__COLUMN_ID = "9b4739bf-349f-4445-a232-c484c12212f9" as Uuid;

export const AMARON__EVENT__SERVICE__DELIVERED_BY__COLUMN_ID = "11a99bc9-d353-4b37-8f82-a0a081121272" as Uuid;

export const AMARON__EVENT__SERVICE__DELIVERED_ON__COLUMN_ID = "af4458d6-791c-4703-bbc2-91319147540e" as Uuid;

export const AMARON__EVENT__SERVICE__CANCELLED_BY__COLUMN_ID = "acb98ec7-c44c-478e-921d-a74496ece6a4" as Uuid;

export const AMARON__EVENT__SERVICE__CANCELLED_ON__COLUMN_ID = "b90793b0-4ec3-42a4-93fd-c247a99027e1" as Uuid;

export const AMARON__EVENT__SERVICE__CANCELLATION_REASON__COLUMN_ID = "66848cc5-5c36-4552-8f15-db9079aa06f9" as Uuid;

export const AMARON__EVENT__SERVICE__RESCHEDULED_BY__COLUMN_ID = "e35cfab7-1912-48e6-bf57-7f8d0c4d6e1d" as Uuid;

export const AMARON__EVENT__SERVICE__RESCHEDULED_ON__COLUMN_ID = "e83e8d4b-8290-4f99-9f17-9d9051cb8c16" as Uuid;

export const AMARON__EVENT__SERVICE__CREATED_BY_ROLE__COLUMN_ID = "80f7fc83-f195-4847-ba36-83857f6772f0" as Uuid;

export const AMARON__EVENT__SERVICE__CUSTOMER_HOUSE_NO__COLUMN_ID = "be6ad44f-e7b0-4205-8fc6-31874b0ffa35" as Uuid;

export const AMARON__EVENT__SERVICE__CUSTOMER_STATE__COLUMN_ID = "ad978637-c908-49d2-a0d0-4542cf30b5bf" as Uuid;

export const AMARON__EVENT__SERVICE__CUSTOMER_CITY__COLUMN_ID = "06e4e970-3e06-41c6-ab3d-24382c0a0a0f" as Uuid;

export const AMARON__EVENT__SERVICE__UTM_PLATFORM__COLUMN_ID = "2bd8ef03-e3af-4f13-9f2e-a645e0cba8f9" as Uuid;

export const AMARON__EVENT__SERVICE__UTM_SOURCE__COLUMN_ID = "2e0c2de8-a193-4e92-a6a5-41cd76890c4c" as Uuid;

export const AMARON__EVENT__SERVICE__UTM_MEDIUM__COLUMN_ID = "9acb53e5-e7fa-4a2c-b568-1a50f8a4fc6f" as Uuid;

export const AMARON__EVENT__SERVICE__UTM_CAMPAIGN__COLUMN_ID = "a13e8bfa-ae12-40c5-9415-16fd43c532ea" as Uuid;

export const AMARON__EVENT__SERVICE__UTM_TERM__COLUMN_ID = "b563e87e-9c75-49e2-8374-7ac6906da864" as Uuid;

export const AMARON__EVENT__SERVICE__UTM_CONTENT__COLUMN_ID = "ee1ad241-94c4-45c8-b5e8-387526d4fe17" as Uuid;

export const AMARON__EVENT__SERVICE__GAD_SOURCE__COLUMN_ID = "2352f1ab-082b-4bcb-9cbe-ded76fd2bd86" as Uuid;

export const AMARON__EVENT__SERVICE__GAD_CAMPAIGN_ID__COLUMN_ID = "b72128ba-364b-4930-a37c-4e19b9689a73" as Uuid;

export const AMARON__EVENT__SERVICE__GBRAID__COLUMN_ID = "776ffc45-a987-4005-ab72-17389d4eb76d" as Uuid;

export const AMARON__EVENT__SERVICE__GCLID__COLUMN_ID = "0e21718e-daee-4b7b-bb3e-233166f1ad31" as Uuid;

export const AMARON__EVENT__SERVICE__FAD_SOURCE__COLUMN_ID = "9f45f09c-2bae-4671-87ca-fe1e024d64df" as Uuid;

export const AMARON__EVENT__SERVICE__FAD_CAMPAIGN_ID__COLUMN_ID = "82062d62-e404-4b18-95e6-8fe31f527a75" as Uuid;

export const AMARON__EVENT__SERVICE__FBRAID__COLUMN_ID = "11aa3ddc-b155-4349-a20c-e0de0f2da8da" as Uuid;

export const AMARON__EVENT__SERVICE__FBCLID__COLUMN_ID = "b6d58064-c6e8-47d6-8367-6df27552105e" as Uuid;

export enum AmaronEnquiryStatusEnum {
    OPEN = "3641d0ee-f9c3-4e2c-8d33-456164d0f73e",
    ENGAGED = "72e2ccc3-7727-40f0-bd9c-43082934059c",
    NON_ENGAGED = "f7d608ac-7662-43f9-95b2-0f0d559679f0",
    ARCHIVE = "e1f92f4a-ce2f-427d-9edd-d76f044c73ae",
    DUPLICATE = "b7e2cb79-6ef4-4b66-8850-67d064125a7d",
}

export enum AmaronCallStatusEnum {
    SCHEDULED = "ce092834-766b-4426-857a-240a60976d3b",
    LOGGED = "966c78c7-2364-4db5-b934-8a9c285e57a2",
    CANCELLED = "d460914b-9f5e-42de-8a90-1f84f2754c6f",
    ARCHIVE = "38023cc9-68b8-440a-8e87-7d7f1f522bd2",
}

export const AMARON__CALL__SCHEDULE__FORM__ID = "a7eb157b-5554-4d6f-a05c-421c84f250d5" as Uuid;

export const AMARON__CALL__LOG__FORM__ID = "8da77d65-4fc6-4550-bbd5-e414c1436c10" as Uuid;

export const AMARON__CALL__EDIT__FORM__ID = "11e0d44a-9a01-4a72-8428-fb7e8b7621af" as Uuid;

export const amaronEnquiryStatuses: Record<AmaronEnquiryStatusEnum, {id: Uuid; displayName: string}> = {
    [AmaronEnquiryStatusEnum.OPEN]: {
        id: AmaronEnquiryStatusEnum.OPEN as Uuid,
        displayName: "Open",
    },
    [AmaronEnquiryStatusEnum.ENGAGED]: {
        id: AmaronEnquiryStatusEnum.ENGAGED as Uuid,
        displayName: "Engaged",
    },
    [AmaronEnquiryStatusEnum.NON_ENGAGED]: {
        id: AmaronEnquiryStatusEnum.NON_ENGAGED as Uuid,
        displayName: "Non-Engaged",
    },
    [AmaronEnquiryStatusEnum.ARCHIVE]: {
        id: AmaronEnquiryStatusEnum.ARCHIVE as Uuid,
        displayName: "Archive",
    },
    [AmaronEnquiryStatusEnum.DUPLICATE]: {
        id: AmaronEnquiryStatusEnum.DUPLICATE as Uuid,
        displayName: "Duplicate",
    },
};

export const amaronCallStatuses: Record<AmaronCallStatusEnum, {id: Uuid; displayName: string}> = {
    [AmaronCallStatusEnum.SCHEDULED]: {
        id: AmaronCallStatusEnum.SCHEDULED as Uuid,
        displayName: "Scheduled",
    },
    [AmaronCallStatusEnum.LOGGED]: {
        id: AmaronCallStatusEnum.LOGGED as Uuid,
        displayName: "Logged",
    },
    [AmaronCallStatusEnum.CANCELLED]: {
        id: AmaronCallStatusEnum.CANCELLED as Uuid,
        displayName: "Cancelled",
    },
    [AmaronCallStatusEnum.ARCHIVE]: {
        id: AmaronCallStatusEnum.ARCHIVE as Uuid,
        displayName: "Archive",
    },
};

export const AMARON__SERVICE__BOOK__FORM__ID = "0ae96c80-934f-4f1e-9475-7361b4695434" as Uuid;

export const AMARON__SERVICE__LOG__FORM__ID = "331b765f-5cf4-46fb-8156-208d61b284f4" as Uuid;

export const AMARON__SERVICE__EDIT__FORM__ID = "d7fd0eb3-f7ef-4ae0-9dfe-02f965575e44" as Uuid;

export const amaronServiceCategories: Record<AmaronServiceCategoryEnum, {id: Uuid; displayName: string}> = {
    [AmaronServiceCategoryEnum.BOOKED]: {
        id: AmaronServiceCategoryEnum.BOOKED as Uuid,
        displayName: "Booked",
    },
    [AmaronServiceCategoryEnum.CANCELLED]: {
        id: AmaronServiceCategoryEnum.CANCELLED as Uuid,
        displayName: "Cancelled",
    },
    [AmaronServiceCategoryEnum.DELIVERED]: {
        id: AmaronServiceCategoryEnum.DELIVERED as Uuid,
        displayName: "Delivered",
    },
    [AmaronServiceCategoryEnum.RE_SCHEDULED]: {
        id: AmaronServiceCategoryEnum.RE_SCHEDULED as Uuid,
        displayName: "Re-Scheduled",
    },
    [AmaronServiceCategoryEnum.ARCHIVE]: {
        id: AmaronServiceCategoryEnum.ARCHIVE as Uuid,
        displayName: "Archive",
    },
};

/** Select options for Category — excludes internal Archive value. */
export function getAmaronServiceCategorySelectOptions(): Array<{id: Uuid; displayName: string}> {
    return Object.values(amaronServiceCategories)
        .filter((category) => String(category.id) !== String(AmaronServiceCategoryEnum.ARCHIVE))
        .map((category) => ({
            id: category.id,
            displayName: category.displayName,
        }));
}
